/**
 * Service: passes
 */
angular.module('acme.common.service.passes', [
  'acme.common.service.passesSeries',
  'acme.common.service.passesAttributes'
])
.service('PassesService', ['PassesSeriesService', 'PassesAttributesService', function(PassesSeriesService, PassesAttributesService) {

    return {

      model: {
        name: '',
        state: 'draft',
        characters: 10
      },
      series: PassesSeriesService,
      attributes: PassesAttributesService,

      init: function() {
        return true;
      },

      resetModel: function() {
        this.model = {
          name: '',
          state: 'draft',
          characters: 10
        };
        this.series.resetModel();
        this.attributes.resetModel();
      },

      setModel: function(model) {
        if (model.id) {
          this.model.id = model.id;
        }
        this.model.name = model.name;
        this.model.state = model.state;
        this.model.characters = model.characters;
        this.series.setModel(model.series);
        this.attributes.setModel(model.attributes);
      },

      getModel: function() {
        return this.model;
      },

      getConfig: function() {

        return angular.extend({}, angular.copy(this.model), {
          series: this.series.getModel(),
          attributes: this.attributes.getModel()
        });
      }

    };

}]);